var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.037C0 18.65 5.372 24.03 12 24.03l.03-7.49H9.206v-3.492h2.824v-1.754c0-2.526 1.857-4.584 4.19-4.584h2.81v3.47h-2.81c-.334 0-.705.446-.705 1.062v1.784h3.514v3.507h-3.5v6.962c4.927-1.5 8.471-6.07 8.471-11.458C24 5.395 18.628.023 12 .023S0 5.403 0 12.037Z",
    fill: "#969391"
  })));
};
export default SvgFacebook;